import { render, staticRenderFns } from "./exclusions-duree.vue?vue&type=template&id=8da3d828&scoped=true"
import script from "./exclusions-duree.vue?vue&type=script&lang=js"
export * from "./exclusions-duree.vue?vue&type=script&lang=js"
import style0 from "./exclusions-duree.vue?vue&type=style&index=0&id=8da3d828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da3d828",
  null
  
)

export default component.exports